import { render, staticRenderFns } from "./ProjectMinimalListItem.vue?vue&type=template&id=661a9b90&scoped=true"
import script from "./ProjectMinimalListItem.vue?vue&type=script&lang=ts"
export * from "./ProjectMinimalListItem.vue?vue&type=script&lang=ts"
import style0 from "./ProjectMinimalListItem.vue?vue&type=style&index=0&id=661a9b90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661a9b90",
  null
  
)

export default component.exports